(function () {
  if (window.QePurchaseOptionScriptLoaded) return;
  window.QePurchaseOptionScriptLoaded = true;

  function getCardPreference(card) {
    var selectedOption = card.querySelector('.sls-option:checked')
      || card.querySelector('.sls-option-container.sls-active .sls-option');
    if (!selectedOption) return null;
    var isOneOff = selectedOption && selectedOption.dataset.type === 'one_time';
    var mode = isOneOff ? 'once' : 'subscription';
    var selectedContainer = selectedOption && selectedOption.closest('.sls-option-container');
    var interval = selectedContainer && selectedContainer.querySelector('select[name="subs_interval"]');
    var variant = card.querySelector('input[name="id"]');

    return {
      mode: mode,
      sellingPlan: mode === 'subscription' && interval ? interval.value : '',
      variant: variant ? variant.value : '',
    };
  }

  function updateProductLink(link) {
    var card = link.closest('[data-qe-product-card]');
    if (!card) return;

    var preference = getCardPreference(card);
    var destination = new URL(link.dataset.qeProductUrl || link.href, window.location.origin);
    // With no card choice, let the product widget apply the merchant default.
    if (preference) destination.searchParams.set('purchase', preference.mode);
    else destination.searchParams.delete('purchase');

    var variant = card.querySelector('input[name="id"]');
    if (variant?.value) destination.searchParams.set('variant', variant.value);
    if (preference?.sellingPlan) {
      destination.searchParams.set('selling_plan', preference.sellingPlan);
    } else {
      destination.searchParams.delete('selling_plan');
    }

    link.href = destination.pathname + destination.search + destination.hash;
  }

  function updateCardPrice(card) {
    var priceTarget = card.querySelector('[data-qe-card-price]');
    if (!priceTarget) return;

    var selectedOption = card.querySelector('.sls-option:checked')
      || card.querySelector('.sls-option-container.sls-active .sls-option');
    var option = selectedOption && selectedOption.closest('.sls-option-container');
    var currentMoney = option && option.querySelector('.sls-price .money');
    if (!currentMoney) return;

    var currentPrice = currentMoney.textContent.trim();
    if (priceTarget.textContent.trim() !== currentPrice) priceTarget.textContent = currentPrice;
  }

  function syncCard(card) {
    if (!card) return;
    var link = card.querySelector('[data-qe-purchase-link]');
    if (link) updateProductLink(link);
    updateCardPrice(card);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-qe-purchase-link]');
    if (link) updateProductLink(link);
  }, true);

  document.addEventListener('change', function (event) {
    var card = event.target.closest('[data-qe-product-card]');
    if (!card) return;
    syncCard(card);
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-qe-product-card]');
    if (!card || !event.target.closest('.sls-option-container, [role="radio"]')) return;
    window.setTimeout(function () { syncCard(card); }, 0);
    window.setTimeout(function () { syncCard(card); }, 120);
  });

  function initCards() {
    var cards = document.querySelectorAll('[data-qe-product-card]');
    cards.forEach(function (card) {
      syncCard(card);
      var observer = new MutationObserver(function () { syncCard(card); });
      observer.observe(card, { childList: true, subtree: true });
    });
  }

  function applyProductPreference() {
    var params = new URLSearchParams(window.location.search);
    var requestedMode = params.get('purchase');
    if (requestedMode !== 'once' && requestedMode !== 'subscription') return true;

    var requestedPlan = params.get('selling_plan');
    var productRoot = document.querySelector('[data-qe-pdp], [data-qe-rx-pdp], product-info');
    if (!productRoot) return false;

    var customButton = productRoot.querySelector('[data-qe-plan="' + requestedMode + '"]');
    var customSelect = productRoot.querySelector('[data-qe-selling-plan]');
    if (customButton && customButton.getAttribute('aria-pressed') !== 'true') customButton.click();
    if (requestedMode === 'subscription' && requestedPlan && customSelect) {
      var customOption = customSelect.querySelector('option[value="' + CSS.escape(requestedPlan) + '"]');
      if (customOption && customSelect.value !== requestedPlan) {
        customSelect.value = requestedPlan;
        customSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var sealContainer = productRoot.querySelector('.sealsubs-container');
    if (!sealContainer) return Boolean(customButton);

    var sealSelector = requestedMode === 'once'
      ? '.sls-option[data-type="one_time"]'
      : '.sls-option[data-type="subscription"]';
    var sealOptions = Array.from(sealContainer.querySelectorAll(sealSelector));
    var sealOption = sealOptions.find(function (option) {
      var optionCard = option.closest('.sls-option-container');
      if (optionCard.classList.contains('sls-disabled-option-container')) return false;
      if (requestedMode !== 'subscription' || !requestedPlan) return true;
      var requestedInterval = optionCard.querySelector('option[value="' + CSS.escape(requestedPlan) + '"]');
      return requestedInterval && !requestedInterval.disabled;
    });
    if (!sealOption) return false;

    if (!sealOption.checked) {
      sealOption.click();
    }

    var interval = sealOption.closest('.sls-option-container').querySelector('select[name="subs_interval"]');
    if (requestedMode === 'subscription' && requestedPlan && interval) {
      var planOption = interval.querySelector('option[value="' + CSS.escape(requestedPlan) + '"]');
      if (planOption && interval.value !== requestedPlan) {
        interval.value = requestedPlan;
        interval.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    return sealOption.checked
      && (requestedMode !== 'subscription' || !requestedPlan || !interval || interval.value === requestedPlan);
  }

  function initProductPreference() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('purchase')) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (applyProductPreference() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards, { once: true });
    document.addEventListener('DOMContentLoaded', initProductPreference, { once: true });
  } else {
    initCards();
    initProductPreference();
  }
})();
